export default __webpack_public_path__ + "static/media/kabe_walk_thumb.6ab16a56.png";